import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackEmailChangeRequested.meta';

export type UseTrackEmailChangeRequestedParams = {
  user_id: string;
  new_email: string;
};

export const useTrackEmailChangeRequested = () => {
  const { track } = useAnalyticsUtilities();

  const trackEmailChangeRequested = useCallback(
    (params: UseTrackEmailChangeRequestedParams) => {
      track(META.name, params, { integrations: { 'Customer.io (Actions)': true } });
    },
    [track],
  );

  return { trackEmailChangeRequested };
};
